export default __webpack_public_path__ + "static/media/swipe-up.54954927.svg";